export default "__VITE_ASSET__Q7$bE9Lv__"